'use client'

import { useState } from 'react'
import s from './ModalContact.module.scss'
import { Modal } from '@/components/Modal'
import { ContactForm } from '@/components/ContactForm'
import type { SchoolContactData } from '@/components/ContactForm'
import { useDict } from '@/lib'

interface ModalContactProps {
  isOpen: boolean
  onClose: () => void
  school?: SchoolContactData // Optional school data for school contact
  globalSocials?: Record<string, string> | null // Optional global socials data
  companyData?: Record<string, string> | null // Optional company data
}

export function ModalContact({
  isOpen,
  onClose,
  school,
  globalSocials,
  companyData,
}: ModalContactProps) {
  const dict = useDict('modal-contact')

  const handleFormSubmit = (formData: any) => {
    console.log('Form submitted:', formData)
    // Form handling is now done inside ContactForm component
  }

  if (!dict) return null

  // Modal title based on context
  const modalTitle = school ? `Kontakt ze szkołą` : dict.title

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={modalTitle}>
      <ContactForm
        consentText={dict.consent}
        onSubmit={handleFormSubmit}
        school={school}
        companyData={companyData}
        globalSocials={globalSocials}
      />
    </Modal>
  )
}
